import React, { useState } from "react";

const services = [
  {
    title: "Cardiovascular Health",
    description:
      "Your heart health is influenced by genetics. Our cardiovascular genetic testing helps assess your risk for heart-related conditions.",
    features: [
      "Coronary Artery Disease",
      "Myocardial Infarction",
      "Hypertension",
      "Heart Failure",
      "Atrial Fibrillation",
      "Long QT Syndrome",
      "Total Cholesterol Levels",
      "HDL Cholesterol",
      "LDL Cholesterol"
    ],
    whyItMatters:
      "Identifying your genetic risk can help in preventing heart disease through early lifestyle changes, targeted treatments, and preventive care.",
   
  },
  {
    title: "Pancreas",
    description:
      "Genetics play a key role in how your body processes insulin and regulates blood sugar.",
    features: ["Type 1 Diabetes", "Type 2 Diabetes", "Insulin Sensitivity", "Blood Sugar Response to Food"],
    whyItMatters:
      "A personalized nutrition and lifestyle plan can help manage or reduce your risk of diabetes.",
   
  },
  {
    title: "Digestive Health",
    description:
      "Your gut health affects your overall well-being, and genetics can influence your risk for digestive disorders. Our testing covers",
    features: [
" Crohn’s Disease"," Inflammatory Bowel Disease (IBD)","irritable bowel syndrome (IBS)"," Ulcerative Colitis" ,"Celiac Disease"," Gluten Sensitivity",

    ],
    whyItMatters:
      " By understanding your gut health risks, you can adapt your diet and lifestyle to minimize symptoms and maintain a healthy digestive system.",

  },

  {
    title: "Thyroid Function",
    description:
      "The thyroid plays a crucial role in metabolism and hormone balance. Our thyroid genetic tests help detect:",
    features: ["Hypothyroidism",
       "Autoimmune Thyroid Disease",
      "Thyroid Function",
      ],
    whyItMatters:
      "Early detection of thyroid issues can help in managing symptoms and maintaining metabolic health.",
    
  },
  {
    title: "Brain Health",
    description:
      "Brain function and mental health are deeply connected to genetics. Our tests provide insights into your risk for:",
    features: ["Alzheimer’s Disease",
      " anxiety disorder",
      " borderline personality disorder",
   "   obsessive-compulsive disorder (OCD)",
     " ADHD",
     " Migraines",
      " Parkinson’s Disease",
      ],
    whyItMatters:
      "Knowing your genetic predisposition to neurological and mental health disorders allows for early intervention and lifestyle modifications",
    },
  {
    title: "Muscle & Bone Health",
    description:
      "Your genetic profile influences how your muscles and bones develop, heal, and perform. Our tests analyse:",
    features: ["Gout",
       "Joint Injury Risk",
       "Fractures",
      " Osteoporosis",
       "Muscle Inflammation",
       "Ankle Injury Susceptibility",
       "Muscle Strength",
       "Bone Density",
      ],
    whyItMatters:
      "Why It Matters: Understanding your genetic risks can help prevent injuries and optimize bone and muscle health.",
    
  },
  {
    title: "Sensitivities",
    description:
      "Your genes influence how your body reacts to different foods and substances. Our sensitivity tests assess your body’s response to:",
    features: ["Bitter Taste Sensitivity",
       "Caffeine Sensitivity",
       "Lactose Sensitivity",
       "Salt Sensitivity",
       "Alcohol Flush Reaction",
      ],
    whyItMatters:
      "Identifying food sensitivities allows for better dietary choices and improved digestive health.",

  },
  {
    title: "Vitamin Absorption",
    description:
      "Your body’s ability to absorb vitamins is genetically determined. We analyse your genetic tendency for deficiencies in:",
    features: ["Vitamin A",
       "Vitamin B12",
       "Vitamin B2",
       "Vitamin B6",
       "Vitamin B9 (Folate)",
       "Vitamin D",
       "Vitamin E",
       "Vitamin K",
       "Vitamin C",
      ],
    whyItMatters:
      " Personalized vitamin recommendations help prevent deficiencies and optimize overall health.",
   
  },
  {
    title: "Essential Mineral Levels",
    description:
      "Minerals play a crucial role in energy production, immune function, and overall health. We test your genetic predisposition to deficiencies in:",
    features: ["Calcium",
     " Copper",
      "Iron"
,     "  Magnesium",
       "Selenium",
     "  Sodium",
      " Zinc",
      ],
    whyItMatters:
      "Knowing your genetic predisposition allows you to optimize your diet and prevent health complications.",
   
  },
  {
    title: " Body Weight",
    description:
      "Weight management is influenced by genetics. Our genetic weight analysis helps you understand:",
    features: [ "Obesity Risk",
      "Weight Gain Tendency",
     " Exercise Benefit for Weight Loss",
   "  Benefit of Brisk Walking",
"     Low-Fat Diet Effectiveness",
   "  Mediterranean Diet Effectiveness",
 "     Low-Carbohydrate Diet Effectiveness",
     ],
    whyItMatters:
      "Tailoring your diet and exercise plan to your genetic profile enhances weight management success.",
   
  },
  {
    title: "Macromolecules",
    description:
      "Your metabolism depends on a complex balance of amino acids and metabolites. Our testing covers:",
    features: ["Uric Acid Levels",
     " Urea Levels",
    " Tyrosine",
      "Proline",
    " Ornithine",
  "    Lysine",
     "Leucine",
      "Isoleucine",
      "Glycine",
     "Arginine",
    " Asparagine",
     "Alanine",
    "  Acetate",
     ],
    whyItMatters:
      "Understanding your metabolic pathways helps in optimizing diet and preventing metabolic disorders.",
   
  },
  {
    title: "Nutritional Disorders",
    description:
      "Genetics can also play a role in nutritional disorders. Our tests assess risks for:",
    features: ["Proteinuria (Excess Protein in Urine)",
     " Glucosuria (Excess Sugar in Urine)",
     "Bulimia Nervosa",
     "Anorexia Nervosa",
     
     ],
    whyItMatters:
      "Early genetic insights allow for preventive strategies and tailored treatment approaches.",
   
  },


];

const ServiceCard = ({ service }) => {
  const [flipState, setFlipState] = useState(0); 

  const handleFlip = () => {
    setFlipState((prev) => (prev + 1) % 3); 
  };

  return (
    <div
      className="relative w-full h-64 bg-white shadow-lg rounded-lg overflow-hidden transform transition-all duration-500 hover:shadow-xl cursor-pointer"
      onClick={handleFlip}
    >
      
      {flipState === 0 && (
        <div className="absolute w-full h-full flex flex-col justify-center items-center p-6">
          <h3 className="text-xl font-semibold text-center">{service.title}</h3>
          <p className="text-gray-600 text-center mt-2">{service.description}</p>
        </div>
      )}

 
      {flipState === 1 && (
        <div className="absolute w-full h-full bg-blue-500 text-white flex flex-col justify-center items-center p-6">
          <h3 className="text-xl font-semibold text-center">Features</h3>
          <ul className="mt-2 text-center text-sm">
            {service.features.map((feature, i) => (
              <li key={i}>{feature}</li>
            ))}
          </ul>
        </div>
      )}

      {flipState === 2 && (
        <div className="absolute w-full h-full bg-green-500 text-white flex flex-col justify-center items-center p-6">
          <h3 className="text-xl font-semibold text-center">Why It Matters</h3>
          <p className="text-center text-sm mt-2">{service.whyItMatters}</p>
        </div>
      )}
    </div>
  );
};

const ServicesGrid = () => {
  return (
    <>
      <div className="subpage-header py-10 mt-[86px]">
        <div className="container mx-auto px-4">
          <div className="row flex justify-center">
            <div className="subpage-header-box text-center">
              <h1 className="text-4xl font-bold text-gray-800">Services</h1>
              <ol className="breadcrumb flex justify-center space-x-2 text-gray-600 mt-2">
                <li>
                  <a href="/" className="hover:text-blue-500 transition">Home</a>
                </li>
                <li>/</li>
                <li>Services</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
        {services.map((service, index) => (
          <ServiceCard key={index} service={service} />
        ))}
      </div>
    </>
  );
};

export default ServicesGrid;
